import {BaseAnalyticsEvent} from "./base-analytics-event";

export class PageViewEvent extends BaseAnalyticsEvent {
  url: String;

  constructor(url: String) {
    super('','','page-view');

    this.url = url;
  }

  get properties() {
    const properties = super.properties;

    properties.url = this.url;

    return properties;
  }

  get isPopulated(): Boolean {
    let isPopulated = super.isPopulated;

    isPopulated &= !!this.url;

    return isPopulated;
  }
}
